
export const twUserColors = [ 
	'amber', 
	'blue', 
	'cyan', 
	'emerald', 
	'fuchsia', 
	'green', 
	'indigo', 
	'lime', 
	'orange', 
	'pink', 
	'purple', 
	'red', 
	'rose', 
	'sky', 
	'teal', 
	'violet', 
	'yellow', 
]
